<script setup lang="ts">
import HeaderComponent from '@/shared/ui/HeaderComponent.vue'

withDefaults(defineProps<{ title?: string; itemId?: string }>(), {
  title: '',
  itemId: '',
})
</script>

<template>
  <div
    class="flex flex-col items-stretch gap-3 mb-6 sm:flex-row sm:items-center sm:justify-between sm:gap-2"
  >
    <div class="flex gap-2">
      <HeaderComponent v-if="title" :title="title" :item-id="itemId" />
    </div>
    <div class="flex items-center gap-2 flex-wrap">
      <slot />
    </div>
  </div>
</template>
